<template>
  <div class="container-fluid col-sm-12 col-xs-12 ls-no-padding">
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>

    <form @keypress.enter.prevent @submit.prevent="doActions()" class="ls-form">

      <div class="row">
        <div class="ls-float-right col-md-12 col-xs-12 col-sm-12 ls-no-padding-left ls-md-margin-bottom">
          <div data-ls-module="collapse" :class="[ 'ls-collapse',  showCollapse ? 'ls-collapse-opened' : '' ]">
            <div @click="toogleCollapse()" class="ls-collapse-header">
              <h4 class="ls-title-4">{{ $t('contracts.labels.contract_settings') }}</h4>
            </div>
            <div class="ls-collapse-body" id="30">
              <div class="row d-flex flex-wrap">
                <div class="col-lg-12 ls-display-flex flex-wrap-wrap align-itens-end">
                  <div class="col-lg-3 col-xs-12 ls-no-padding">
                    <label class="ls-label">
                      <b class="ls-label-text ls-xs-margin-bottom">{{ $t('contracts.attributes.settings.days_to_overdue_invoice') }}
                        <popover :position="'right'">
                          <div slot="content">{{ $t('contracts.new.popover.days_to_overdue_invoice') }}</div>
                        </popover>
                      </b>
                      <div class="col-lg-2 col-xs-2 ls-no-padding">
                        <input type="number"
                        class="ls-field-sm"
                        min=0
                        v-validate="'required'"
                        v-model='settings.days_to_overdue_invoice.value'>
                      </div>
                    </label>
                  </div>
                  <div class="col-lg-2 col-xs-12">
                    <label class="ls-label" :class="{'ls-error': errors.has($t('contracts.attributes.day_expiration')) }">
                      <b class="ls-label-text ls-xs-margin-bottom">{{ $t('contracts.attributes.day_expiration') }}</b>
                      <div class="col-lg-4 col-xs-2 ls-no-padding">
                        <input
                          class="ls-field-sm"
                          type="number"
                          data-test="'contracts.attributes.day_expiration'"
                          min="1"
                          max="31"
                          v-validate="'required|valid_dd'"
                          v-model="contract_params.day_expiration"
                          :name="$t('contracts.attributes.day_expiration')">
                      </div>
                    <small class="ls-help-message" v-show="errors.has($t('contracts.attributes.day_expiration'))">{{ errors.first($t('contracts.attributes.day_expiration')) }}</small>
                    </label>
                  </div>
                  <div class="col-lg-3 col-xs-12">
                    <label class="ls-label" :class="{'ls-error': errors.has($t('contracts.attributes.url_notification')) }">
                      <b class="ls-label-text ls-xs-margin-bottom">{{ $t('contracts.attributes.url_notification') }}</b>
                      <input
                        class="ls-field-sm"
                        type="text"
                        data-test="'contracts.attributes.url_notification'"
                        v-model="contract_params.url_notification"
                        :placeholder="$t('contracts.placeholder.url_notification')"
                        :name="$t('contracts.attributes.url_notification')">
                      <small class="ls-help-message" v-show="errors.has($t('contracts.attributes.url_notification'))">{{ errors.first($t('contracts.attributes.url_notification')) }}</small>
                    </label>
                  </div>
                </div>
                <div class="col-lg-12 ls-no-padding">
                  <div class="col-lg-6 col-xs-12">
                    <input
                    type="checkbox"
                    name="settings.generate_service_tax_invoices.value"
                    class="ls-float-left"
                    v-model="settings.generate_service_tax_invoices.value">
                    <label>
                      <p><span class="txt-check">{{ $t('contracts.attributes.settings.generate_service_tax_invoices') }}</span></p>
                    </label>
                  </div>
                  <div class="col-lg-6 col-xs-12">
                    <authorized-link tag="index_contract_tax">
                      <button type="button" @click.prevent="openTaxesModal" class="ls-btn ls-btn-primary ls-no-margin ls-float-right">
                        <i class="fa fa-usd" aria-hidden="true"></i>
                        <span>{{ $t('contracts.edit.manage_taxes') }}</span>
                      </button>
                    </authorized-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="col-lg-6">
            <h2>{{ $t('contracts.edit.contract_plans')}}</h2>
          </div>
          <div class="col-lg-6">
            <authorized-link tag="create_contract_plan">
              <div class=" col-md-12 col-sm-12 col-xs-12 ls-no-padding">
                <button type="button" class="ls-btn ls-btn-primary ls-no-margin ls-float-right" @click.prevent="addPlan"><i class="fa fa-plus" aria-hidden="true"></i><span class="ls-xs-margin-left">{{ $t('application.button.add_plan') }}</span></button>
              </div>
            </authorized-link>
          </div>
        </div>
      </div>

      <div class="row" v-for='index in contractPlans.length'>
        <div :id='index' class="col-sm-12 col-lg-12 col-xs-12 col-md-12 ls-box-filter ls-xs-space">
          <fieldset>
            <div :data-vv-scope="index" class="col-md-12" :class="pageWidth > 1300 ? 'd-flex' : ''">
              <label class="ls-no-padding col-md-12 col-xs-12" :class="{ 'ls-error': errors.has(index.toString() + '.' + $t('contracts.plan'))}">
                <v-select
                  v-if="contractPlans[index - 1].changeable === undefined"
                  @input.native="clearFilter"
                  @search="onSearchPlan"
                  :closeOnSelect="true"
                  label="name"
                  class="ls-sm-margin-bottom"
                  transition="none"
                  v-bind:ref="index"
                  v-model="contractPlans[(index - 1)].plan"
                  v-validate="'required'"
                  :data-vv-scope="index"
                  @input="changedLabel($event, (index - 1))"
                  :placeholder="$t('contracts.placeholder.search_by_plan_name')"
                  :options="plansOptions"
                  :value.sync="contractPlans[(index - 1)]">
                  <template slot="no-options">{{ $t('contracts.new.find_plan') }}</template>
                </v-select>
                <input v-else type="text" class="col-md-12 col-sm-12 col-xs-12 ls-sm-margin-bottom" disabled v-model="contractPlans[(index - 1)].plan.name" name="">
                <small class="ls-help-message" v-show="errors.has(index.toString() + '.' + $t('contracts.plan'))">{{ errors.first(index.toString() + '.' + $t('contracts.plan')) }}</small>
              </label>
              <div v-if="contractPlansLength > 1 || contractPlans[index -1].deleted" class="col-md-12 ls-no-padding ls-no-margin-top">
                <button type="button" :id="'button'+index" class="ls-btn ls-btn-danger ls-float-right  ls-no-margin" @click.prevent="tooglePlan(index - 1)">{{ $t('contract_plans.buttons.inactivate') }}</button>
              </div>
            </div>

            <div class="container-fluid" v-if="contractPlans[(index - 1)].plan">

              <div class="row">

                <div class="no-wrap col-md-12 col-lg-12 ls-no-padding">

                  <div class="col-xlg-1 col-lg-1-5 col-xs-6 ls-no-padding-right">
                    <label class="ls-label" :class="{ 'ls-error': errors.has(index.toString() + '.' + $t('plans.attributes.periodicity')) }">
                      <span class="ls-label-text col-xs-12 ls-sm-margin-bottom ls-no-padding">
                        {{ $t('contracts.new.periodicity') }}
                        <popover :position="'right'">
                          <div slot="content">{{ $t('contracts.labels.periodicity') }}</div>
                        </popover>
                      </span>
                      <div class="col-xlg-6 col-lg-6 ls-no-padding">
                        <input
                          type="number"
                          min="0"
                          max="48"
                          step="1"
                          required
                          name="plans.attributes.periodicity"
                          v-model="contractPlans[(index - 1)].periodicity"
                          v-validate="'required|decimal:0|min_value:1'"
                          :name="$t('plans.attributes.periodicity')"
                          :data-vv-scope="index">
                      </div>
                      <small class="ls-help-message" v-show="errors.has(index.toString() + '.' + $t('plans.attributes.periodicity'))">{{ errors.first(index.toString() + '.' + $t('plans.attributes.periodicity')) }}</small>
                    </label>
                  </div>

                  <div class="col-xlg-1 col-lg-1-5 col-xs-6">
                    <label class="ls-label">
                      <span class="ls-label-text ls-sm-margin-bottom d-flex">Qtde Lançada</span>
                      <div class="col-lg-5 col-xlg-6 ls-no-padding">
                        <input type="number" disabled v-model="contractPlans[index - 1].quantity_launched">
                      </div>
                    </label>
                  </div>

                  <div class="col-xlg-1 col-lg-1-5 col-xs-6">
                    <label class="ls-label" :class="{ 'ls-error': errors.has(index.toString() + '.' + $t('plans.attributes.quantity')) }">
                      <span class="ls-label-text col-xs-12 ls-sm-margin-bottom ls-no-padding ls-sm-padding-rigth d-flex">
                        {{ $t('contracts.new.quantity') }}
                        <popover class="margin-left-3px" :position="'right'">
                          <div slot="content">{{ $t('contracts.labels.quantity') }}</div>
                        </popover>
                      </span>
                      <div class="col-lg-5 col-xlg-6 ls-no-padding">
                        <input
                          type="number"
                          min="0"
                          step="1"
                          required
                          name="plans.attributes.quantity"
                          v-model="contractPlans[(index - 1)].quantity"
                          v-validate="{ required: true, max_quantity: [], decimal: 0, valid_quantity: [contractPlans[(index - 1)].quantity_launched, contractPlans[index - 1].original_quantity] }"
                          :data-vv-scope="index"
                          :name="$t('plans.attributes.quantity')">
                      </div>
                      <small class="ls-help-message" v-show="errors.has(index.toString() + '.' + $t('plans.attributes.quantity'))">{{ errors.first(index.toString() + '.' + $t('plans.attributes.quantity')) }}</small>
                    </label>
                  </div>

                  <div class="col-lg-2 col-xlg-2 col-xs-6 ls-no-padding-left">
                    <label class="ls-label" :class="{ 'ls-error': errors.has(index.toString() + '.' + $t('plans.attributes.price')) }">
                      <b class="ls-label-text ls-sm-margin-bottom">{{ $t('plans.new.value') }}</b>
                      <div class="col-xlg-8">
                        <money-input
                          v-model="contractPlans[(index - 1)].price"
                          v-validate="'required|onlyPositive'"
                          :value="contractPlans[(index - 1)].price"
                          @updateValue="(value) => { contractPlans[(index - 1)].price = value }"
                          required
                          step="2"
                          :name="$t('plans.attributes.price')"
                          :data-vv-scope="index">
                        </money-input>
                      </div>
                      <small class="ls-help-message" v-show="errors.has(index.toString() + '.' + $t('plans.attributes.price'))">{{ errors.first(index.toString() + '.' + $t('plans.attributes.price')) }}</small>
                    </label>
                  </div>

                  <authorized-link tag="update_contract_plan_entry">

                    <div class="col-lg-1-5 col-xlg-1 col-xs-6">
                      <label class="ls-label">
                        <span class="ls-label-text ls-sm-margin-bottom">Desc Lançados</span>
                        <div class="col-xlg-4 col-lg-6 ls-no-padding">
                          <input type="number" disabled v-model="contractPlans[index - 1].contract_plan_entries[0].quantity_launched">
                        </div>
                      </label>
                    </div>

                    <div class="col-xlg-1 col-lg-1-5 col-xs-6 ls-no-padding">
                      <label class="ls-label ls-no-padding-left" :class="{'ls-error': errors.has(index.toString() + '.' + $t('contracts.new.discount_quantity')) }">
                        <span class="ls-label-text ls-sm-margin-bottom d-flex">{{ $t('contracts.new.discount_quantity')}}
                          <popover class="margin-left-3px" :position="'right'">
                            <div slot="content" class="ls-xs-margin-left">{{ $t('contracts.labels.discount_quantity') }}</div>
                          </popover>
                        </span>
                        <div class="col-xlg-6 col-lg-6 ls-no-padding">
                          <input
                            type="number"
                            v-model="contractPlans[(index - 1)].contract_plan_entries[0].quantity"
                            required
                            min="0"
                            v-validate="{ required: true ,decimal: 0, max_quantity: [], valid_quantity: [contractPlans[(index - 1)].contract_plan_entries[0].quantity_launched, contractPlans[index - 1].contract_plan_entries[0].original_quantity] }"
                            :name="$t('contracts.new.discount_quantity')"
                            :data-vv-scope="index"
                            :placeholder="$t('contracts.new.discount_quantity')" />
                        </div>
                        <small class="ls-help-message" v-show="errors.has(index.toString() + '.' + $t('contracts.new.discount_quantity'))">{{ errors.first(index.toString() + '.' + $t('contracts.new.discount_quantity')) }}</small>
                      </label>
                    </div>

                    <div class="col-xlg-2 col-lg-2 col-xs-12">
                      <label class="ls-label" :class="{ 'ls-error': errors.has(index.toString() + '.' + $t('contracts.new.discount_price')) }">
                        <b class="ls-label-text ls-sm-margin-bottom">{{ $t('contracts.new.discount_price') }}</b>
                        <div class="col-xlg-8">
                          <money-input
                            v-model="contractPlans[(index - 1)].contract_plan_entries[0].price"
                            v-validate="'required|onlyPositive'"
                            :value="contractPlans[(index - 1)].contract_plan_entries[0].price"
                            @updateValue="(value) => { contractPlans[(index - 1)].contract_plan_entries[0].price = value }"
                            :data-vv-scope="index"
                            :name="$t('contracts.new.discount_price')">
                          </money-input>
                        </div>
                        <small class="ls-help-message" v-show="errors.has(index.toString() + '.' + $t('contracts.new.discount_price'))">{{ errors.first(index.toString() + '.' + $t('contracts.new.discount_price')) }}</small>
                      </label>
                    </div>
                  </authorized-link>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>


      <div class="row col-md-12">
        <div class="col-md-6">
          <button class="ls-btn-primary ls-float-left" @click.prevent='redirectToContract()'><i class="fa fa-arrow-left" aria-hidden="true"></i><span class="ls-xs-margin-left">{{ $t('contracts.buttons.come_back') }}</span></button>
        </div>
        <div class="col-md-6 ls-no-padding">
          <button class="ls-btn-primary ls-float-right" type="submit"><i class="fa fa-floppy-o" aria-hidden="true"></i><span class="ls-xs-margin-left">{{ $t('contracts.buttons.save') }}</span></button>
        </div>
      </div>
    </form>
    <modal-confirm-changes v-model="confirmChanges"></modal-confirm-changes>
    <modal-taxes v-model="modalTaxes" :linkedTaxes="linkedTaxes" :unlinkedTaxes="unlinkedTaxes" :save="true"></modal-taxes>
  </div>
</template>

<script>
  import { mapActions, mapMutations, mapGetters } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import { setFilteredPlans, clearFilteredPlans } from 'src/app/pages/contracts/vuex/mutations-types'
  import MoneyInput from 'src/app/components/shareds/money-input/MoneyInput'
  import ModalTaxes from './components/ModalTaxes'
  import ModalConfirmChanges from './components/ModalConfirmChanges'
  import filter from 'src/utils/filter'
  import Popover from 'src/app/components/shareds/popover/Popover'
  import scroll from 'src/utils/scroll'
  import money from 'src/utils/money'
  import _ from 'lodash'

  export default {
    watch: {
      contractPlans: function () {
        this.scrollPage()
      }
    },
    name: 'edit-contract',
    components: { Breadcrumb, MoneyInput, Popover, ModalConfirmChanges, ModalTaxes },
    data () {
      return {
        money: money,
        plansOptions: [],
        haveErrors: false,
        showCollapse: true,
        linkedTaxes: '',
        unlinkedTaxes: '',
        contractPlans: [],
        modalTaxes: { show: false },
        confirmChanges: { show: false },
        settings: {
          days_to_overdue_invoice: { value: 0 },
          generate_service_tax_invoices: { value: false }
        },
        deletedPlans: [],
        contract_params: {
          day_expiration: '',
          url_notification: '',
          id: ''
        },
        crumbs: {
          'ico': 'ls-ico-edit-admin',
          'section': this.$t('contracts.edit.edit_subscription'),
          'paths': {
            0: {
              'title': this.$t('contracts.new.subscriptions'),
              'path': '/contracts/new'
            },
            1: {
              'title': this.$t('contracts.edit.edit_subscription'),
              'path': ''
            }
          }
        }
      }
    },
    mounted () {
      this.getContract()
      this.getAllPlans()
    },
    computed: {
      ...mapGetters(['contract', 'plans', 'filteredPlans', 'taxes']),
      contractPlansLength: function () {
        return (this.contractPlans.length - this.deletedPlans.length)
      },
      pageWidth: () => {
        return window.innerWidth
      }
    },
    methods: {
      ...mapActions(['loadPlans', 'loadTaxes', 'loadContract', 'editContract', 'updateContract', 'createInvoice', 'editContractPlan', 'createContractPlan', 'inactivateContractPlan', 'loadSetting', 'editContractSetting']),
      ...mapMutations(['clearFlash', 'addFlash']),
      getContract () {
        this.$loader.show()
        this.loadContract(this.$route.params.id).then(this.aftergetContract)
      },
      aftergetContract () {
        this.$loader.hide()
        this.getContractSettings()
        this.contract_params.day_expiration = this.contract.day_expiration
        this.contract_params.url_notification = this.contract.url_notification
        this.contractPlans = this.activeContractPlans(this.contract.contract_plans)
        this.formatContractPlansEntries(this.contractPlans)
      },
      activeContractPlans (contractPlans) {
        let actives = contractPlans.filter(function (contractPlan) {
          if (contractPlan.status === 'active') {
            contractPlan.original_quantity = contractPlan.quantity
            return contractPlan
          }
        })
        return actives
      },
      // Metodo insere no de contract plan entries caso o contract plan nao o possua, isto e necessario para garantir o padrao da estrutura de insercao de dados
      formatContractPlansEntries (contractPlans) {
        for (let contractPlan of contractPlans) {
          contractPlan.deleted = false
          contractPlan.changeable = false
          if (contractPlan.quantity === null) contractPlan.quantity = 0
          if (contractPlan.contract_plan_entries[0] !== undefined) {
            contractPlan.contract_plan_entries[0].price = Math.abs(contractPlan.contract_plan_entries[0].price)
            contractPlan.contract_plan_entries[0].original_quantity = contractPlan.contract_plan_entries[0].quantity
            continue
          }
          contractPlan.contract_plan_entries.push({
            price: 0.00,
            quantity: 0
          })
        }
        contractPlans
      },
      getAllPlans () {
        this.$loader.show()
        this.loadPlans().then(this.afterPlansLoad)
      },
      afterPlansLoad () {
        this.$loader.hide()
        this.plansOptions = this.getPlansOptions()
      },
      getPlansOptions () {
        let plans = []
        for (let plan of this.plans) {
          plans.push({
            code: plan.code,
            name: plan.name,
            price: plan.price,
            periodicity: plan.periodicity,
            quantity: plan.quantity || 0,
            contract_plan_entries: [{
              quantity: 0,
              price: 0.00
            }]
          })
        }
        return plans
      },
      // Fim da execucao dos metodos chamados no carregamento da pagina

      // Metodos utilizados para busca dinamica de valores no select de planos
      onSearchPlan (search, loading) {
        loading(true)
        this.search(loading, search, this)
      },
      search: _.debounce((loading, search, self) => {
        self.getPlans(search)
        setTimeout(() => { loading(false) }, 350)
      }, 350),
      getPlans (params) {
        this.filterPlansQuery('plan[name]', params)
        let parameters = filter.toQuery(this.filteredPlans)
        this.loadPlans(parameters).then(this.afterPlansLoad)
      },
      filterPlansQuery (key, value) {
        if (value !== '' && value !== undefined) {
          this.$store.commit(setFilteredPlans, { key: key, value: value })
          this.$store.commit(setFilteredPlans, { key: 'plan[active]', value: true })
        } else {
          this.$store.commit(clearFilteredPlans)
        }
      },

      // Metodos responsaveis por adicionar ou remover planos
      addPlan () {
        this.contractPlans.push({ plan: '', quantity: 0, contract_plan_entries: [{ quantity: 0, price: 0.00 }] })
        let self = this
        setTimeout(function () {
          self.scrollPage()
          self.$refs[self.contractPlans.length][0].$el.getElementsByClassName('form-control')[0].focus()
        }, 100)
      },
      tooglePlan (index) {
        this.clearFlash()
        if (this.contractPlans[index].id !== undefined) {
          let element = document.getElementById(index + 1)
          let button = document.getElementById('button' + (index + 1))
          if (this.contractPlans[index].deleted === true) {
            this.markAsActive(element, button, index)
          } else {
            this.markAsInactive(element, button, index)
          }
        } else {
          this.contractPlans.splice(index, 1)
        }
      },

      markAsActive (element, button, index) {
        for (let iteration in this.deletedPlans) {
          if (this.deletedPlans[iteration] === this.contractPlans[index].id) {
            var position = iteration
            break
          }
          continue
        }
        this.deletedPlans.splice(position, 1)
        this.contractPlans[index].deleted = false
        element.classList.remove('deleted-plan')
        button.textContent = this.$t('contract_plans.buttons.inactivate')
      },

      markAsInactive (element, button, index) {
        this.deletedPlans.push({ id: this.contractPlans[index].id, index: index })
        this.contractPlans[index].deleted = true
        button.textContent = this.$t('contract_plans.buttons.activate')
        element.classList.add('deleted-plan')
      },

      // Metodo altera o valor do contract plan existente para o novo selecionado
      changedLabel (event, indexContractPlan) {
        if (event.contract_plan_entries === undefined) return
        let newPlan = this.contractPlans[indexContractPlan].plan
        let contractPlan = this.contractPlans[indexContractPlan]
        let price = newPlan.price
        contractPlan.price = price
        contractPlan.periodicity = newPlan.periodicity
        contractPlan.plan = newPlan
        if (contractPlan.contract_plan_entries[0].price) {
          contractPlan.contract_plan_entries[0].price = Math.abs(contractPlan.contract_plan_entries[0].price)
        }
        this.contractPlans[indexContractPlan] = contractPlan
      },
      doActions () {
        this.confirmChanges.show = true
      },

      validateBeforeSubmit () {
        this.$loader.show()
        this.$validator.validateScopes().then(this.afterValidate)
      },
      // Este metodo realiza a acao de criar um novo contract plan ou editar um ja existente
      async afterValidate (response) {
        if (response) {
          this.updateSetting(this.contract.id)
          await this.editOrCreateContractPlans().then(this.inactivePlans).then(this.editContract).then(this.redirectWithFlash)
          this.$loader.hide()
          scroll.scrollToFlash()
        } else {
          if (this.noPlanError()) { this.addFlash({ message: this.$t('contracts.edit.no_plan_error'), type: 'ls-alert-danger' }) }
          this.$loader.hide()
          scroll.scrollToFlash()
        }
      },
      async editContract () {
        this.contract_params.id = this.contract.id
        let response = await this.updateContract(this.contract_params)
        if (response.status !== 200) this.haveErrors = true
        return response
      },
      async editOrCreateContractPlans () {
        for (let contractPlan of this.contractPlans) {
          var response = ''
          if (contractPlan.id !== undefined) {
            response = await this.editContractPlan(this.requestParams(contractPlan))
          } else {
            response = await this.createContractPlan(this.requestParams(contractPlan))
          }
          if (response.status === 422 || response.status === 404) this.haveErrors = true
        }
      },
      async inactivePlans () {
        if (this.deletedPlans[0] === undefined) return
        for (let deletedPlan of this.deletedPlans) {
          let parameters = { id: deletedPlan.id }
          var response = await this.inactivateContractPlan(parameters)
        }
        if (response.status !== 200) this.haveErrors = true
      },
      redirectWithFlash () {
        this.redirectToContract()
        setTimeout(() => {
          if (this.haveErrors === false) {
            this.addFlash({ message: this.$t('contracts.edit.update_success'), type: 'ls-alert-success' })
          } else {
            this.addFlash({ message: this.$t('contracts.edit.update_fail'), type: 'ls-alert-danger' })
          }
        }, 200)
      },
      redirectToContract () {
        this.$router.push('/contracts/' + this.contract.id)
      },
      requestParams (contractPlan) {
        let parameters = {
          contract_id: this.contract.id,
          id: contractPlan.id,
          contract_plan: {
            price: contractPlan.price,
            periodicity: contractPlan.periodicity,
            code: contractPlan.plan.code,
            quantity: contractPlan.quantity,
            entry: {
              id: contractPlan.contract_plan_entries[0].id === undefined ? null : contractPlan.contract_plan_entries[0].id,
              price: contractPlan.contract_plan_entries[0].price,
              quantity: contractPlan.contract_plan_entries[0].quantity
            }
          }
        }
        return parameters
      },
      // Metodos referentes as configuracoes a nivel de assinatura
      getContractSettings () {
        for (let setting in this.settings) {
          let params = { id: this.contract.id, setting_tag: setting, value: this.settings[setting].value }
          this.loadSetting(params).then(this.defineSetting.bind(null, setting))
        }
      },
      defineSetting (setting, response) {
        if (setting === 'generate_service_tax_invoices') {
          this.settings[setting].value = response.data === true
        } else {
          this.settings[setting].value = response.data
        }
      },
      updateSetting (contractId) {
        for (let setting in this.settings) {
          let params = { id: contractId, setting_tag: setting, value: this.settings[setting].value }
          this.editContractSetting(params)
        }
      },
      // Abre a modal de impostos
      openTaxesModal () {
        let params = 'tax[active]=true'
        this.loadTaxes(params).then(this.showTaxesModal)
      },
      showTaxesModal () {
        this.getLinkedTaxes()
        this.getUnlinkedTaxes()
        this.modalTaxes.show = true
        this.modalTaxes.callback = scroll.scrollToFlash
      },
      getLinkedTaxes () {
        if (this.linkedTaxes.length || this.unlinkedTaxes) return this.linkedTaxes
        this.linkedTaxes = this.taxes.filter((tax) => {
          return this.verifyContractLink(tax)
        })
      },
      verifyContractLink (tax) {
        let linked = false
        for (let contractTax of this.contract.contract_taxes) {
          if (tax.id === contractTax.tax_id && contractTax.active) linked = true
        }
        return linked
      },
      getUnlinkedTaxes () {
        if (this.unlinkedTaxes.length) return this.unlinkedTaxes
        this.unlinkedTaxes = this.taxes.filter((tax) => {
          return !this.verifyContractLink(tax)
        })
      },
      // Metodos do collapse
      toogleCollapse () {
        this.$helper.$emit('closeCollapses', this.type)
        this.showCollapse = !this.showCollapse
      },
      closeCollapse (type) {
        if (this.type !== type) {
          this.showCollapse = false
        }
      },
      // Metodos auxiliares
      noPlanError () {
        for (let contractPlan of this.contractPlans) {
          if (contractPlan.plan === '') return true
        }
        return false
      },
      clearFilter () {
        this.plansOptions = []
      },
      scrollPage () {
        window.scrollTo(0, document.body.scrollHeight)
      },
      currentDay () {
        return new Date().getDate()
      }
    }
  }
</script>
<style>
  .d-flex {
    display: flex !important;
  }
  .align-self-center {
    align-self: center;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .no-wrap {
    flex-wrap: nowrap;
  }
  .justify-content-space-around {
    justify-content: space-around;
  }
  .justify-content-flex-end {
    justify-content: flex-end;
  }
  .align-items-center {
    align-items: center;
  }
  .span-text {
    color: #888888;
    font-size: 12px;
  }
  .deleted-plan {
    background-color: #f508081c !important;
  }
  .margin-left-3px {
    margin-left: 3px;
  }
</style>



// WEBPACK FOOTER //
// Edit.vue?e77c2ad4